import styled from "styled-components";

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;

  .ant-table-wrapper {
    font-family: var(--fontMono);
  }
`;

export const TableContainer = styled.div`
  height: 100%;

  .ant-table-body {
    overflow: auto !important;
  }

  .ant-pagination {
    margin: 8px 0 0 0;
    padding: 0 8px;
    background: white;
  }

  .any-table-placeholder {
    width: 100%;
    height: 100%;
  }

  .ant-table-sticky-holder {
    top: -16px !important; //sticky scroll ignores widget padding
  }

  .facilityModeTable {
    overflow: auto;

    .ant-table-empty .ant-table-container {
      min-width: 800px;
    }
  }
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background-color: rgb(186, 189, 194);
  color: #4b4b4b;
  border-radius: 5px;
  font-size: 14px;
  padding: 2px 8px;
  text-wrap: auto;
  text-align: center;
  min-width: 80%;
`;

export const EmptyTablePlaceholder = styled.div`
  height: 100%;
  min-height: 100px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background-color: #fafafa;
  position: relative;
`;

///CustomFacilityHeaderRow Styles
export const RightAlignedCell = styled.div`
  text-align: right;
`;
